import { TQueryReward, TReward } from '@src/modules/reward'

import { request } from './config'

export const CreateReward = (data: TReward) => request({ url: 'reward', method: 'POST', data })
export const getLisReward = (params: TQueryReward, token: string) =>
  request({ url: 'reward', method: 'GET', params }, { token })
export const getLisRewardApp = (params: TQueryReward, token: string) =>
  request({ url: 'reward/app', method: 'GET', params }, { token })
export const removeRewardById = (id: string) => request({ url: `reward/${id}`, method: 'DELETE' })
export const removeRewardByIds = (data: any) => request({ url: 'reward/delete-many', method: 'POST', data })
export const getRewardById = (id: string, token: string) => request({ url: `reward/${id}`, method: 'GET' }, { token })
export const postReward = (data: TReward) => request({ url: 'reward', method: 'POST', data })
export const patchRewardById = (id: string, data: TReward) => request({ url: `reward/${id}`, method: 'PATCH', data })
export const getRewardTotal = (token: string) => request({ url: 'reward/total', method: 'GET' }, { token })
